<template>
  <GmapMap
    :center="center"
    :zoom="12"
    map-type-id="satellite"
    :style="{
      width: '100%',
      height: xsOnly ? '300px' : '450px',
      'border-radius': smAndDown ? '0' : '8px',
      overflow: 'hidden',
    }"
  >
    <GmapPolygon
      v-for="(item, index) in coordinates"
      :key="index"
      :paths="convertCoordinates(item.coordinates)"
      :options="polygonOptions"
    ></GmapPolygon>

    <GmapPolygon :paths="polygonPath" :options="polygonOptions"></GmapPolygon>
  </GmapMap>
</template>

<script>
export default {
  props: {
    coordinates: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      center: {},
      polygonPath: [],
      polygonOptions: {
        strokeColor: "yellow",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "transparent",
        fillOpacity: 0.35,
      },
    };
  },
  computed: {
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.polygonPath = this.coordinates[0].coordinates.coordinates[0].map(
      (coordinate) => ({
        lat: coordinate[1],
        lng: coordinate[0],
      })
    );

    this.center = this.calculateCenter();
  },
  methods: {
    calculateCenter() {
      let totalLat = 0;
      let totalLng = 0;

      for (const coordinate of this.polygonPath) {
        totalLat += coordinate.lat;
        totalLng += coordinate.lng;
      }

      const centerLat = totalLat / this.polygonPath.length;
      const centerLng = totalLng / this.polygonPath.length;

      return {
        lat: centerLat,
        lng: centerLng,
      };
    },

    convertCoordinates(coordinates) {
      const polygonCoordinates = coordinates.coordinates[0];

      const coordinatesCount = polygonCoordinates.length;

      let sumX = 0;
      let sumY = 0;

      for (let i = 0; i < coordinatesCount; i++) {
        sumX += polygonCoordinates[i][0];
        sumY += polygonCoordinates[i][1];
      }

      const averageX = sumX / coordinatesCount;
      const averageY = sumY / coordinatesCount;

      const marker = { lat: averageY, lng: averageX };

      return polygonCoordinates.map((coord) => ({
        lat: coord[1],
        lng: coord[0],
      }));
    },
  },
};
</script>
